import React, { useState, useEffect, useContext } from 'react';

import PharmacyBanner from '../component/Pharmacy/Banner'
import TopCategories from '../component/Pharmacy/TopCategories'
import TopDepartments from '../component/Pharmacy/TopDepartments'
import Videos from '../component/Pharmacy/TopDepartments/videos'
import OfferArea from '../component/Pharmacy/Offer'
import FeaturedProduct from '../component/Pharmacy/FeaturedProduct'
import DealMonth from '../component/Pharmacy/DealMonth'
import HotItems from '../component/Pharmacy/HotItems'
import TopBrand from '../component/Pharmacy/TopBrand'
import BannerBottom from '../component/Pharmacy/BannerBottom'
import FooterTop from '../component/Pharmacy/FooterTop'
import TodayDeal from '../component/Fashion/TodayDeal'
import GiftBanner from '../component/Pharmacy/giftBanner';
import DownloadBanner from '../component/Pharmacy/downloadBanner';
import { AuthContext } from '../context/AuthContext';
import { connect } from "react-redux";
import * as actions from "../actions/service";
import * as category from "../actions/category";
import * as user from "../actions/user";
import * as offer from "../actions/offer";
import * as coupon from "../actions/coupon";
import * as department from "../actions/department";
import * as doctor from "../actions/doctor";
import * as blogs from "../actions/blog";
import * as results from "../actions/result";
import * as event from "../actions/event";
import * as giftcard from "../actions/giftcard";
import InstgramSlider from '../component/Common/Instagram';
import parse from 'html-react-parser';
import _ from 'lodash'
import { useTranslation } from 'react-i18next';

const Pharmacy = (props) => {
  const { t, i18n } = useTranslation();
  const { getAuthUser, getCurrentBranch } = useContext(AuthContext)
  const authUser = getAuthUser()
  const currentBranch = getCurrentBranch()
  const [offerSlides, setOfferSlides] = useState([]);
  const [eventSlides, setEventSlides] = useState([]);
  const [resultSlides, setResultSlides] = useState([]);
  const [showFilteredServices, setShowFilteredServices] = useState(false);
  const [filteredServices, setFilteredServices] = useState([]);
  const [packages, setPackages] = useState([]);
  const [featuredServices, setFeaturedServices] = useState([]);
  const [featuredPackages, setFeaturedPackages] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [featuredCoupons, setFeaturedCoupons] = useState([]);
  const [keyword, setKeyword] = useState("");
 

  useEffect(() => {

     props.fetchTopSlider();
     props.fetchBottomSlider();
    //branch: currentBranch, 
    props.fetchCategories();
    props.fetchRandomPackages({ status: 'active' })
    props.fetchFeaturedServices({ status: 'active', featured: true });
    props.fetchDepartments();
    props.fetchAllTestimonials();
    props.fetchDoctors();
    props.fetchResults(1, 5)
    props.fetchPagination(1, 5)
    props.fetchAllgiftcard()
    
    // if (authUser) {
    //   props.fetchCart(authUser.id)

    //   const onSuccess = (res) => {

    //   }
    //   props.updateUserCart(authUser.id, {
    //     role: 'customer'
    //   }, onSuccess)
    // }

  }, []);

  useEffect(() => {
    setPackages(props.packages);
  }, [props.packages]);

  useEffect(() => {
    console.log('12121244', props)
  }, [props]);


  useEffect(() => {
    let allfilters = _.groupBy(props.featuredServices, 'type')
    setFeaturedServices(allfilters['product'] ? allfilters['product'] : [])
    setFeaturedPackages(allfilters['package'] ? allfilters['package'] : [])
    setFeaturedProducts(allfilters['item'] ? allfilters['item'] : [])
    setFeaturedCoupons(allfilters['coupon'] ? allfilters['coupon'] : [])
    // console.log("------->",allfilters['coupon'])
  }, [props.featuredServices]);

  useEffect(() => {

    setOfferSlides(_.map(props.topSlider, 'image'));
    setEventSlides(_.map(props.bottomSlider, 'image'))

  }, [props.topSlider, props.bottomSlider]);

    useEffect(() => {
      let slides = [];
        if (props.results)
            props.results.forEach(ele => {
                slides.push(parse("<img src="+ process.env.REACT_APP_IMG_URL+ele.icon+" style='height:250px; width: 330px;'/>"))
            });
        setResultSlides(slides)
    }, [props.results]);

  return (
    <>

      <PharmacyBanner offerSlides={props.topSlider} eventSlides={eventSlides} />
      {/* {featuredCoupons.length > 0 && <TodayDeal data={featuredCoupons} heading={2} title="Deals of The Month" />}
      <DealMonth /> */}
      {/* <OfferArea /> */}
      {props.randomPackages.length > 0 && <TodayDeal data={props.randomPackages} heading={2} title="Recommended" />}
      {/* <FeaturedProduct /> */}
      {featuredServices.length > 0 && <TodayDeal data={_.sampleSize(featuredServices, 4)} heading={1} title={t('ourservices')} subheading={t('ourservicessubheading')} isTiles={true}/>}
      {resultSlides.length > 0  && <HotItems slides={resultSlides}/>}
      {props.departments.length > 0  && <TopDepartments data={props.departments} />}

      {props.events.length > 0  && <TopBrand testimonials={props.events}/>}
      {props.doctors.length > 0  && <InstgramSlider container={true} TeamData={props.doctors.filter((e) => e.role === 'doctor')}/>}
      <DownloadBanner />
      {props.homeblogs.length > 0  && <GiftBanner homeblogs={props.homeblogs}/>}
      {featuredPackages.length > 0 && <TodayDeal  data={featuredPackages} heading={1} title={t('ourpackages')} subheading={t('ourpackagessubheading')} />}
      {props.giftcards.length > 0  && <Videos data={props.giftcards} />}

      {/* {featuredProducts.length > 0 && <TodayDeal data={featuredProducts} heading={2} title="Featured Products"/>} */}
      {/*<BannerBottom /> */}
      {/* <FooterTop /> */}
      {/* <TopCategories data={props.categories}/> */}
    </>


  )
}


const mapStateToProps = state => ({
  packages: state?.service?.services,
  meta: state?.service?.metaService,
  categories: state.category.categories,
  users: state.user.users,
  cart: state.user.cart,
  cartArray: state.user.cartArray,
  offers: state?.offer?.offers,
  randomPackages: state?.service?.randomPackages,
  topSlider: state.offer.topSlider,
  bottomSlider: state.offer.bottomSlider,
  featuredServices: state.service.featured,
  featuredCoupons: state.coupon.featured,
  departments: state?.department?.departments,
  doctors: state?.doctor?.doctors,
  homeblogs: state?.blog?.blogs,
  results: state?.result?.results,
  events: state?.event?.events,
  giftcards: state?.giftcard?.giftcards
})

const mapActionToProps = {

  update: actions.update,
  fetchCategories: category.fetchAll,
  // updateUser: user.update,
  // updateUserCart: user.updateCart,
  // fetchCart: user.fetchCart,
  // fetchAllOffers: offer.fetchAll,
   fetchBottomSlider: offer.fetchBottomSlider,
   fetchTopSlider: offer.fetchTopSlider,
  fetchRandomPackages: actions.fetchRandomPackages,
  fetchFeaturedServices: actions.getFeatured,
  fetchFeaturedCoupons: coupon.getFeatured,
  fetchDepartments: department.fetchAll,
  fetchDoctors : doctor.fetchAll,
  fetchPagination: blogs.Pagination,
  fetchResults: results.Pagination,
  fetchAllTestimonials: event.fetchAll,
  fetchAllgiftcard: giftcard.fetchAll
}

export default connect(mapStateToProps, mapActionToProps)(Pharmacy);

